import { api as $axios } from '@/helpers/interceptors'
import { GET_PAYMENT_LIST } from '@/constants/path'
import snakeCaseKeys from 'snakecase-keys'

const setUnLoading = (commit, status = false) => {
  commit('SET_STATE', {
    key: 'isLoading',
    value: status,
  })
}

const attributePath = (paymentTypeId) =>
  `${GET_PAYMENT_LIST}/${paymentTypeId}/attributes`

const state = () => ({
  data: [],
  isLoading: false,
})

// getters
const getters = {}

// actions
const actions = {
  async getPaymentList({ commit }) {
    setUnLoading(commit, true)
    try {
      const res = await $axios(`${GET_PAYMENT_LIST}`, 'get')
      commit('SET_STATE', {
        key: 'data',
        value: res?.data?.data,
      })
      setUnLoading(commit)
    } catch (error) {
      commit('SET_STATE', { key: 'data', value: [] })
      setUnLoading(commit)
    }
  },
  // eslint-disable-next-line no-empty-pattern
  async updatePayment({}, payload) {
    await $axios(`${GET_PAYMENT_LIST}/${payload.id}`, 'put', {
      title: payload.title,
      short_description_bnn: payload.shortDescriptionBnn,
      on_top_discount_percent_bnn: payload.onTopDiscountPercentBnn,
      short_description_studio7: payload.shortDescriptionStudio7,
      on_top_discount_percent_studio7:
        payload.onTopDiscountPercentStudio7,
      bnn: payload.bnn,
      studio7: payload.studio7,
    })
  },

  /**
   * ไม่มี GET /payment-types/{id} จึงอ่านจากรายการทั้งหมด
   * (เปิด URL ตรง ๆ จะยังไม่มี state.data จึงโหลดก่อน)
   */
  async getPaymentById({ state, dispatch }, id) {
    if (!state.data?.length) await dispatch('getPaymentList')
    return state.data?.find((x) => x.id === +id)
  },

  // eslint-disable-next-line no-empty-pattern
  async getPaymentTypeAttributes({}, paymentTypeId) {
    const res = await $axios(attributePath(paymentTypeId), 'get')
    return res?.data?.data ?? []
  },

  /**
   * upsert ด้วย key (payment_type_id, bu, campaign_id)
   * ไม่ใช่ partial update — ต้องส่ง title และ html ทุกครั้ง
   */
  // eslint-disable-next-line no-empty-pattern
  async upsertPaymentTypeAttribute({}, payload) {
    await $axios(
      attributePath(payload.paymentTypeId),
      'put',
      snakeCaseKeys({
        bu: payload.bu,
        campaignId: payload.campaignId ?? 0,
        gatewayPromotionTitle: payload.title || null,
        gatewayPromotionHtml: payload.html || null,
      }),
    )
  },

  // eslint-disable-next-line no-empty-pattern
  async deletePaymentTypeAttribute({}, { paymentTypeId, id }) {
    await $axios(`${attributePath(paymentTypeId)}/${id}`, 'delete')
  },
}

// mutations
const mutations = {
  SET_STATE(state, ops) {
    state[ops.key] = ops.value
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
